import {domLoader} from "@/loader.js";

window.toastLoaded = false

const TOAST_ICONS = {
  success: "✓",
  error: "✕",
  warning: "!",
  default: "ℹ",
}

domLoader(function () {
  if (window.toastLoaded) return
  if (document.body && document.body.classList.contains("admin-dashboard-body")) return
  window.toastLoaded = true

  window.Livewire.on("toast", (data) => {
    data = data[0];
    dumpToast(data)
  })

  const sortToast = () => {
    const containers = document.querySelectorAll(".toast-container:not(.toast-leaving)")
    containers.forEach((container, index) => {
      container.style.setProperty("--toast-stack-index", String(index))
    })
  }

  const dismissToast = (container) => {
    if (!container || container.classList.contains("toast-leaving")) return

    container.classList.remove("toast-visible")
    container.classList.add("toast-leaving")

    const remove = () => {
      container.remove()
      sortToast()
    }

    container.addEventListener("animationend", (event) => {
      if (event.animationName === "siteToastLeave") {
        remove()
      }
    }, {once: true})

    setTimeout(remove, 400)
  }

  const dismissScheduler = (container, time) => {
    setTimeout(function () {
      dismissToast(container)
    }, time)
  }

  let toastData = document.getElementById("toast-data")
  if (toastData) {
    let dataAttr = toastData.getAttribute("data-data")
    if (dataAttr) {
      try {
        let data = JSON.parse(dataAttr)
        if (data && data.message) {
          dumpToast(data)
        }
      } catch (e) {}
    }
  }

  function dumpToast(data) {
    let _message = data.message
    let type = data.type || "default"
    let time = (parseInt(data.time, 10) || 4) * 1000

    let container = document.createElement("div")
    let icon = document.createElement("div")
    let content = document.createElement("div")
    let message = document.createElement("div")
    let close = document.createElement("button")
    let progress = document.createElement("div")

    container.classList.add("toast-container", type)
    icon.classList.add("toast-icon")
    icon.textContent = TOAST_ICONS[type] || TOAST_ICONS.default
    content.classList.add("toast-content")
    message.classList.add("message")
    close.classList.add("close")
    close.type = "button"
    close.setAttribute("aria-label", "بستن")
    close.innerHTML = "×"
    progress.classList.add("toast-progress")

    message.innerHTML = _message
    content.appendChild(message)
    container.appendChild(icon)
    container.appendChild(content)
    container.appendChild(close)
    container.appendChild(progress)
    container.style.setProperty("--toast-duration", time + "ms")
    container.style.setProperty("--toast-stack-index", String(document.querySelectorAll(".toast-container:not(.toast-leaving)").length))

    close.addEventListener("click", () => dismissToast(container))
    dismissScheduler(container, time)
    document.body.appendChild(container)

    requestAnimationFrame(() => {
      sortToast()
      container.classList.add("toast-visible")
    })
  }

  window.showSiteToast = (message, type = "default", time = 4) => {
    dumpToast({ message, type, time })
  }
});
